export default __webpack_public_path__ + "eb8042cc9af7ad40de3ed76a21a6589b.glb";